import { getScroll, rafThrottle, scrollTopTo } from '@/shared';
import classnames from 'classnames';
import { useState, useEffect, useRef } from 'react';
import { SvgIcon } from '../SvgIcon';
import './index.less';

interface BackTopProps {
  /** 什么高度可见 */
  visibilityHeight?: number;
  /** 设置该元素，则以该元素为目标吸底 */
  stickyBottomTarget?: React.RefObject<HTMLElement | null>;
  stickyBottomMargin?: number;
}

export function BackTop(
  props: BackTopProps & React.HTMLAttributes<HTMLDivElement>,
) {
  const [visible, setVisible] = useState<boolean>(false);
  const [sticky, setSticky] = useState<boolean>(false);
  const [stickyHeight, setStickyHeight] = useState<number>(0);
  const el = useRef<HTMLDivElement>(null);

  const {
    className,
    children,
    visibilityHeight = 400,
    stickyBottomTarget,
    stickyBottomMargin = 0,
    ...otherProps
  } = props;

  const handleScroll = rafThrottle(() => {
    if (!el.current) {
      return;
    }
    // 当前所在高度是否进入可视高度
    const scrollTop = getScroll(window);
    setVisible(scrollTop > visibilityHeight);

    // 设置吸底
    if (stickyBottomTarget?.current) {
      const targetRect = stickyBottomTarget.current.getBoundingClientRect();
      /** 视口高度 */
      const vHeight =
        window.innerHeight || document.documentElement.clientHeight;
      // 吸底元素进入可视区则吸底
      const shouldSticky = targetRect.bottom > 0 && targetRect.top < vHeight;
      setSticky(shouldSticky);
      setStickyHeight(targetRect.height + stickyBottomMargin);
    }
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, false);

    return () => {
      handleScroll.cancel();
      window.removeEventListener('scroll', handleScroll, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibilityHeight, stickyBottomTarget, stickyBottomMargin]);

  const handleClick = () => {
    scrollTopTo(0);
  };

  const style = sticky ? { bottom: `${stickyHeight}px` } : undefined;
  return (
    <div
      ref={el}
      className={classnames('mag-backtop', className, {
        visible: visible,
        sticky: sticky,
      })}
      style={style}
      {...otherProps}
      onClick={handleClick}
    >
      <SvgIcon name="collapse" />
    </div>
  );
}
